import { graphql } from "../../graphql";

export const ShareVoiceMetricsTableFragment = graphql(`
  fragment ShareVoiceTableFragment on ShareVoiceTable @_unmask {
    segmentName
    segmentId
    totalArticles
    netImpact
    grossImpact
    netSentiment
    grossPositiveImpact
    grossNeutral
    grossNegativeImpact
    socialEngagement
    mentions
    averageArticleImpact
    averageImpactStrength
  }
`);
